import React from "react";
import styles from "./SummaryCards.module.css";

const SummaryCards = ({ summary }) => {
  const cards = [
    { label: "إجمالي السيولة", value: summary.totalCash, className: styles.cash },
    { label: "إجمالي الأصول", value: summary.totalAssets, className: styles.asset },
    { label: "إجمالي رأس المال", value: summary.totalCapital, className: styles.total },
  ];

  return (
    <div className={styles.grid}>
      {cards.map((card) => (
        <div key={card.label} className={`${styles.card} ${card.className}`}>
          <span className={styles.label}>{card.label}</span>
          <span className={styles.value}>
            {Number(card.value || 0).toLocaleString("ar-EG")} ج.م
          </span>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;